import { IBridgeProvidedAction } from "@vega/bridge";

export const OpenSalesOrderActionId = "open-sales-order";

export class OpenSalesOrderActionData {
    public salesOrderId: number | undefined;
    public salesOrderItemId: number | undefined;
    public proceedingTypeId: number | undefined;
}

export type OpenSalesOrderAction = IBridgeProvidedAction<OpenSalesOrderActionData, void>;
